var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!(_vm.APPREADY))?[_vm._v("No data available.")]:_vm._e(),_c('patient-dashboard',{class:_vm.appReadyClass})],2)}
var staticRenderFns = []

export { render, staticRenderFns }